import React from "react"

function EcommerceA() {
  return (
    <svg viewBox="0 0 266 150" fill="none">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <path
        d="M40.333 48h9.334c.736 0 1.333-.597 1.333-1.333v-9.334c0-.736-.597-1.333-1.333-1.333h-9.334c-.736 0-1.333.597-1.333 1.333v9.334c0 .736.597 1.333 1.333 1.333zm0 0l7.334-7.333L51 44m-7.333-4.333a1 1 0 11-2 0 1 1 0 012 0z"
        stroke="var(--base-500)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={20}
        y={61}
        width={41}
        height={2}
        rx={1}
        fill="var(--solid-900)"
      />
      <rect x={20} y={65} width={13} height={2} rx={1} fill="var(--base-500)" />
      <rect x={20} y={57} width={17} height={2} rx={1} fill="var(--base-400)" />
      <path
        d="M99.333 48h9.334c.736 0 1.333-.597 1.333-1.333v-9.334c0-.736-.597-1.333-1.333-1.333h-9.334c-.736 0-1.333.597-1.333 1.333v9.334c0 .736.597 1.333 1.333 1.333zm0 0l7.334-7.333L110 44m-7.333-4.333a1 1 0 11-2 0 1 1 0 012 0z"
        stroke="var(--base-500)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={79}
        y={61}
        width={41}
        height={2}
        rx={1}
        fill="var(--solid-900)"
      />
      <rect x={79} y={65} width={13} height={2} rx={1} fill="var(--base-500)" />
      <rect x={79} y={57} width={17} height={2} rx={1} fill="var(--base-400)" />
      <path
        d="M158.333 48h9.334c.736 0 1.333-.597 1.333-1.333v-9.334c0-.736-.597-1.333-1.333-1.333h-9.334c-.736 0-1.333.597-1.333 1.333v9.334c0 .736.597 1.333 1.333 1.333zm0 0l7.334-7.333L169 44m-7.333-4.333a1 1 0 11-2 0 1 1 0 012 0z"
        stroke="var(--base-500)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={138}
        y={61}
        width={41}
        height={2}
        rx={1}
        fill="var(--solid-900)"
      />
      <rect
        x={138}
        y={65}
        width={13}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={138}
        y={57}
        width={17}
        height={2}
        rx={1}
        fill="var(--base-400)"
      />
      <path
        d="M217.333 48h9.334c.736 0 1.333-.597 1.333-1.333v-9.334c0-.736-.597-1.333-1.333-1.333h-9.334c-.736 0-1.333.597-1.333 1.333v9.334c0 .736.597 1.333 1.333 1.333zm0 0l7.334-7.333L228 44m-7.333-4.333a1 1 0 11-2 0 1 1 0 012 0z"
        stroke="var(--base-500)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={197}
        y={61}
        width={41}
        height={2}
        rx={1}
        fill="var(--solid-900)"
      />
      <rect
        x={197}
        y={65}
        width={13}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={197}
        y={57}
        width={17}
        height={2}
        rx={1}
        fill="var(--base-400)"
      />
      <path
        d="M40.333 94h9.334c.736 0 1.333-.597 1.333-1.333v-9.334c0-.736-.597-1.333-1.333-1.333h-9.334c-.736 0-1.333.597-1.333 1.333v9.334c0 .736.597 1.333 1.333 1.333zm0 0l7.334-7.333L51 90m-7.333-4.333a1 1 0 11-2 0 1 1 0 012 0z"
        stroke="var(--base-500)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={20}
        y={107}
        width={41}
        height={2}
        rx={1}
        fill="var(--solid-900)"
      />
      <rect
        x={20}
        y={111}
        width={13}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={20}
        y={103}
        width={17}
        height={2}
        rx={1}
        fill="var(--base-400)"
      />
      <path
        d="M99.333 94h9.334c.736 0 1.333-.597 1.333-1.333v-9.334c0-.736-.597-1.333-1.333-1.333h-9.334c-.736 0-1.333.597-1.333 1.333v9.334c0 .736.597 1.333 1.333 1.333zm0 0l7.334-7.333L110 90m-7.333-4.333a1 1 0 11-2 0 1 1 0 012 0z"
        stroke="var(--base-500)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={79}
        y={107}
        width={41}
        height={2}
        rx={1}
        fill="var(--solid-900)"
      />
      <rect
        x={79}
        y={111}
        width={13}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={79}
        y={103}
        width={17}
        height={2}
        rx={1}
        fill="var(--base-400)"
      />
      <path
        d="M158.333 94h9.334c.736 0 1.333-.597 1.333-1.333v-9.334c0-.736-.597-1.333-1.333-1.333h-9.334c-.736 0-1.333.597-1.333 1.333v9.334c0 .736.597 1.333 1.333 1.333zm0 0l7.334-7.333L169 90m-7.333-4.333a1 1 0 11-2 0 1 1 0 012 0z"
        stroke="var(--base-500)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={138}
        y={107}
        width={41}
        height={2}
        rx={1}
        fill="var(--solid-900)"
      />
      <rect
        x={138}
        y={111}
        width={13}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={138}
        y={103}
        width={17}
        height={2}
        rx={1}
        fill="var(--base-400)"
      />
      <path
        d="M217.333 94h9.334c.736 0 1.333-.597 1.333-1.333v-9.334c0-.736-.597-1.333-1.333-1.333h-9.334c-.736 0-1.333.597-1.333 1.333v9.334c0 .736.597 1.333 1.333 1.333zm0 0l7.334-7.333L228 90m-7.333-4.333a1 1 0 11-2 0 1 1 0 012 0z"
        stroke="var(--base-500)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={197}
        y={107}
        width={41}
        height={2}
        rx={1}
        fill="var(--solid-900)"
      />
      <rect
        x={197}
        y={111}
        width={13}
        height={2}
        rx={1}
        fill="var(--base-500)"
      />
      <rect
        x={197}
        y={103}
        width={17}
        height={2}
        rx={1}
        fill="var(--base-400)"
      />
    </svg>
  )
}

export default EcommerceA;
